module.exports = __webpack_public_path__ + "img/facial_hair_mustache_thick.63ba16ad.png";